import { Loader2 } from 'lucide-react';

const FabricLoadingOverlay = ({ label = 'Loading fabric...' }) => (
  <div
    data-testid="fabric-loading-overlay"
    className="absolute inset-0 z-10 flex flex-col items-center justify-center pointer-events-none"
    style={{ background: 'rgba(13, 148, 136, 0.45)', backdropFilter: 'blur(6px)' }}
  >
    <Loader2 className="w-8 h-8 text-white animate-spin" strokeWidth={2} />
    <span className="mt-2 text-xs font-medium text-white/90 tracking-wide">{label}</span>
  </div>
);

export default FabricLoadingOverlay;
